export default "__VITE_ASSET__BO$82zH9__"